export default {
    List: 1,
    Calendar: 2
}